import axios from 'axios';

export const fetcher = (url: string) => axios.get(url).then(res => {
  return { data: res.data, status: res.status };
})
